module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAQlBMVEUAAAAmJC4mJS8lJS8mJC4kJDImJS4mJS8mJS8lJC8mJi4kJC4gICooKCgnJTAmJC4lJC4lJS0mJS4lJTAmJC8mJS9Gu9TaAAAAFXRSTlMA5bSYdxL469OIWDcYC6ucwES7qzu49z41AAAA3ElEQVRIx91VWw6EIAwU5SmCu+v2/lfdmE0sGKCZX+eznSF90U7PRNSHV0TKHzrK7C0oKqDCNqSb3dINdjd9/uqoAbf2+At1sDTpaaYu5tQQML+lkOKRo1pr/2mqLbfMjZMErq7uTpKgDmqzssCWPQ8llZG+ZelC4VE3AUOzR7E1EmPQnsjPDARvdunLmDvpvs6CsytfAj8QJHZ5zlkOqc6aBoIPMWABHBKcNFxWuHHwaKDDB483/IHQLwovAXTNoIsMXZXwMgbXPXpQsJO1GPgoymc3/89u1nF6JH52cE/nJO8OJgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/helpCenter/bit-coin-fill@2x.png
// module id = fTHj
// module chunks = 44